// extracted by mini-css-extract-plugin
module.exports = {"quote":"_33X6gCQ4","logo":"_11HcpPBK","button":"_3vqDsaoN","logoContainer":"_26Ou7KjF","metaTerm":"_2UzpOc-p","metaDescription":"_1Qa_Eqjk"};